module.exports = {"pyme":{"title":"Programa PYME","text":"<p>OPEN HEALTHCARE, S.L. \ntem sido beneficiário de Fundos Europeus, cujo objetivo é melhorar a competitividade das PME, e graças aos quais lançou um Plano de Ação com o objetivo de promover a utilização segura e fiável do ciberespaço e a competitividade das PME durante o ano de 2024. Para isso, contou com o apoio do Programa PME de Cibersegurança da Câmara de Comércio de Sevilha."}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/pt/public/views/pyme.json
// module id = 653
// module chunks = 120